/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const e={absolute:"absolute-direction",relative:"relative-direction"};export{e as directionModeIcons};
